import React from 'react';
import { GoTriangleDown, GoTriangleUp } from 'react-icons/go';
import { Box, chakra, Flex, Icon, Text } from '@chakra-ui/react';

import DataTypes from '../constants/dataTypes';

import { tryFormatDate } from './dateUtil';
import { isNullOrUndefined } from './validationUtil';

export function getRowValue(row, path, fallback = null) {
  const pathArray = path.split('.');
  let value = row.original[pathArray.shift()];
  while (pathArray.length) {
    value = value[pathArray.shift()];
  }

  return value || fallback;
}

export function createHeaderCell(text, position = 'center', withSortArrows = false) {
  return function ({ column }) {
    if (!withSortArrows) return (<Text textAlign={position}>{text}</Text>);

    let headerIcon;

    if (column.isSortedDesc) {
      headerIcon = <Icon aria-label="sorted descending" as={GoTriangleDown} />;
    } else {
      headerIcon = <Icon aria-label="sorted ascending" as={GoTriangleUp} />;
    }

    if (!column.isSorted) {
      headerIcon = (
        <Flex direction="column" justifyContent="center">
          <Icon as={GoTriangleUp} mb="-5px" />
          <Icon as={GoTriangleDown} />
        </Flex>
      );
    }

    return (
      <Flex alignItems="center" justifyContent={position}>
        <Box whiteSpace="nowrap">{text}</Box>
        <chakra.span pl="4">{headerIcon}</chakra.span>
      </Flex>
    );
  };
}

export const getDisplayValueForType = (value, dataType) => {
  if (isNullOrUndefined(value)) return '';

  switch (dataType) {
    case DataTypes.Boolean: {
      if (typeof value === 'boolean') {
        return value.toString();
      }

      return String(!!parseInt(value, 10));
    }

    case DataTypes.Date: {
      return tryFormatDate(value, false);
    }

    case DataTypes.DateTime: {
      return tryFormatDate(value, true);
    }

    case DataTypes.String: {
      return value.toString();
    }

    case DataTypes.Monetary: {
      return `$${Number((Number(value)).toFixed(1)).toLocaleString()}`;
    }

    default:
      return value;
  }
};
